module.exports = __webpack_public_path__ + "media/src/images/dandori/step3-9b950720d54bae1d88bcdf30a54fa100.png";